import './assets/NcRichText-D2BBsB-_.css';
import i from "./Components/NcActionButton.mjs";
import { N as e } from "./chunks/NcActionButtonGroup-BS4fKDux.mjs";
import m from "./Components/NcActionCaption.mjs";
import a from "./Components/NcActionCheckbox.mjs";
import { N as p } from "./chunks/NcActionInput-B_upGNjs.mjs";
import c from "./Components/NcActionLink.mjs";
import s from "./Components/NcActionRadio.mjs";
import N from "./Components/NcActionRouter.mjs";
import { N as n } from "./chunks/NcActions-ClU5w8U1.mjs";
import f from "./Components/NcActionSeparator.mjs";
import l from "./Components/NcActionText.mjs";
import u from "./Components/NcActionTextEditable.mjs";
import { N as d } from "./chunks/NcAppContent-CZUuFw1x.mjs";
import g from "./Components/NcAppContentDetails.mjs";
import A from "./Components/NcAppContentList.mjs";
import { N as S } from "./chunks/NcAppNavigation-8_Bef_ph.mjs";
import { N as b } from "./chunks/NcAppNavigationCaption-DZl4aJXn.mjs";
import v from "./Components/NcAppNavigationIconBullet.mjs";
import { N as T } from "./chunks/NcAppNavigationItem-D7L6HxhH.mjs";
import k from "./Components/NcAppNavigationList.mjs";
import P from "./Components/NcAppNavigationNew.mjs";
import { N as x } from "./chunks/NcAppNavigationNewItem-CRLPUH7B.mjs";
import { N as C } from "./chunks/NcAppNavigationSettings-EcktukV4.mjs";
import I from "./Components/NcAppNavigationSpacer.mjs";
import { N as h } from "./chunks/NcAppSettingsDialog-fgbU_-h8.mjs";
import E from "./Components/NcAppSettingsSection.mjs";
import { N as B } from "./chunks/NcAppSidebar-BbEflEtM.mjs";
import R from "./Components/NcAppSidebarTab.mjs";
import { N as L } from "./chunks/NcAvatar-k_VeT7Vp.mjs";
import { u as ct } from "./chunks/NcAvatar-k_VeT7Vp.mjs";
import { N as y } from "./chunks/NcBreadcrumb-Yg1njNwp.mjs";
import { N as M } from "./chunks/NcBreadcrumbs-DXD2Kiak.mjs";
import O from "./Components/NcButton.mjs";
import { N as D } from "./chunks/NcCheckboxRadioSwitch-BRPYihez.mjs";
import { N as _ } from "./chunks/NcColorPicker-DNGismgl.mjs";
import { N as j } from "./chunks/NcContent-DCmLP8Ly.mjs";
import F from "./Components/NcCounterBubble.mjs";
import { N as W } from "./chunks/NcDashboardWidget-6UWLF9LM.mjs";
import { N as w } from "./chunks/NcDashboardWidgetItem-bFGf6_R7.mjs";
import { N as z } from "./chunks/NcDateTime-GW15p7yp.mjs";
import { u as Nt } from "./chunks/NcDateTime-GW15p7yp.mjs";
import G from "./Components/NcDateTimePicker.mjs";
import V from "./Components/NcDateTimePickerNative.mjs";
import { N as H } from "./chunks/NcDialog-D6YSjidf.mjs";
import { N as K } from "./chunks/NcDialogButton-DQFoaN7q.mjs";
import { N as U } from "./chunks/NcEmojiPicker-B34sLJKs.mjs";
import $ from "./Components/NcEmptyContent.mjs";
import q from "./Components/NcGuestContent.mjs";
import { N as J } from "./chunks/NcHeaderMenu-CXBimxcN.mjs";
import { N as Q } from "./chunks/index-CnpswYi6.mjs";
import { N as X } from "./chunks/NcIconSvgWrapper-BTdzvQGV.mjs";
import { N as Y } from "./chunks/NcListItem-rlwo19vU.mjs";
import { N as Z } from "./chunks/NcListItemIcon-Bwl8bKaY.mjs";
import oo from "./Components/NcLoadingIcon.mjs";
import ro from "./Components/NcModal.mjs";
import to from "./Components/NcNoteCard.mjs";
import { N as io } from "./chunks/NcPasswordField-D91QgkSR.mjs";
import { N as eo } from "./chunks/NcPopover--V3R3EKV.mjs";
import { N as mo } from "./chunks/NcProgressBar-DDAeXyp8.mjs";
import { N as ao } from "./chunks/NcRelatedResourcesPanel-DaLcC_9H.mjs";
import { N as po } from "./chunks/index-BAVa4G2v.mjs";
import { r as ft } from "./chunks/index-BAVa4G2v.mjs";
import { N as co, a as so } from "./chunks/NcRichContenteditable-CaeNwWTC.mjs";
import { N as No } from "./chunks/NcRichText-DVnS4C_H.mjs";
import { N as ut, h as dt, d as gt, i as At, b as St, r as bt, c as vt, a as Tt } from "./chunks/index-CU14QsCg.mjs";
import "@vueuse/core";
import "vue";
import { a as Pt, g as xt, b as Ct, c as It, d as ht, s as Et } from "./chunks/referencePickerModal-ChgMFkNu.mjs";
import "unist-util-visit";
import "unist-builder";
import "@nextcloud/router";
import "@nextcloud/axios";
/* empty css                                                                            */
import { N as no } from "./chunks/NcSelect-BjojUUy7.mjs";
import { N as fo } from "./chunks/NcTextField-BPGi70PD.mjs";
import "@nextcloud/event-bus";
import { N as lo } from "./chunks/NcSavingIndicatorIcon-Bf0SEmgS.mjs";
import { N as uo } from "./chunks/NcSelectTags-CIa3RL2u.mjs";
import { N as go } from "./chunks/NcSettingsInputText-BESxHP0m.mjs";
import { N as Ao } from "./chunks/NcSettingsSection-BzN6JXnV.mjs";
import { N as So } from "./chunks/NcSettingsSelectGroup-BRov--RO.mjs";
import { N as bo } from "./chunks/NcTimezonePicker-jCKohlic.mjs";
import { N as vo } from "./chunks/NcUserBubble-DwKN1aRa.mjs";
import { N as To } from "./chunks/NcUserStatusIcon-Blep5GZX.mjs";
import ko from "./Components/NcTextArea.mjs";
import { isFullscreenState as Rt, useIsFullscreen as Lt } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT as Mt, MOBILE_SMALL_BREAKPOINT as Ot, isMobileState as Dt, useIsMobile as _t, useIsSmallMobile as jt } from "./Composables/useIsMobile.mjs";
import { E as Wt, a as wt, e as zt, g as Gt, s as Vt } from "./chunks/emoji-k4gWHxrE.mjs";
import { u as Kt } from "./chunks/usernameToColor-DrnKFnLP.mjs";
import { directive as Po } from "./Directives/Focus.mjs";
import { directive as xo } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as $t } from "./Mixins/clickOutsideOptions.mjs";
import { default as Jt } from "./Mixins/isFullscreen.mjs";
import { default as Xt } from "./Mixins/isMobile.mjs";
import { VTooltip as Co } from "floating-vue";
import { VTooltip as Zt } from "floating-vue";
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const Io = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton: i,
  NcActionButtonGroup: e,
  NcActionCaption: m,
  NcActionCheckbox: a,
  NcActionInput: p,
  NcActionLink: c,
  NcActionRadio: s,
  NcActionRouter: N,
  NcActionSeparator: f,
  NcActionText: l,
  NcActionTextEditable: u,
  NcActions: n,
  NcAppContent: d,
  NcAppContentDetails: g,
  NcAppContentList: A,
  NcAppNavigation: S,
  NcAppNavigationCaption: b,
  NcAppNavigationIconBullet: v,
  NcAppNavigationItem: T,
  NcAppNavigationList: k,
  NcAppNavigationNew: P,
  NcAppNavigationNewItem: x,
  NcAppNavigationSettings: C,
  NcAppNavigationSpacer: I,
  NcAppSettingsDialog: h,
  NcAppSettingsSection: E,
  NcAppSidebar: B,
  NcAppSidebarTab: R,
  NcAutoCompleteResult: co,
  NcAvatar: L,
  NcBreadcrumb: y,
  NcBreadcrumbs: M,
  NcButton: O,
  NcCheckboxRadioSwitch: D,
  NcColorPicker: _,
  NcContent: j,
  NcCounterBubble: F,
  NcDashboardWidget: W,
  NcDashboardWidgetItem: w,
  NcDateTime: z,
  NcDateTimePicker: G,
  NcDateTimePickerNative: V,
  NcDialog: H,
  NcDialogButton: K,
  NcEmojiPicker: U,
  NcEmptyContent: $,
  NcGuestContent: q,
  NcHeaderMenu: J,
  NcHighlight: Q,
  NcIconSvgWrapper: X,
  NcListItem: Y,
  NcListItemIcon: Z,
  NcLoadingIcon: oo,
  NcMentionBubble: po,
  NcModal: ro,
  NcNoteCard: to,
  NcPasswordField: io,
  NcPopover: eo,
  NcProgressBar: mo,
  NcRelatedResourcesPanel: ao,
  NcRichContenteditable: so,
  NcRichText: No,
  NcSavingIndicatorIcon: lo,
  NcSelect: no,
  NcSelectTags: uo,
  NcSettingsInputText: go,
  NcSettingsSection: Ao,
  NcSettingsSelectGroup: So,
  NcTextArea: ko,
  NcTextField: fo,
  NcTimezonePicker: bo,
  NcUserBubble: vo,
  NcUserStatusIcon: To
}, Symbol.toStringTag, { value: "Module" }));
/**
 * @copyright 2022 Christopher Ng <chrng8@gmail.com>
 *
 * @author Christopher Ng <chrng8@gmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const et = (o) => o.type === "click" || o.type === "keydown" && o.key === "Enter";
/**
 * @copyright Copyright (c) 2018 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const ho = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: Po,
  Linkify: xo,
  Tooltip: Co
}, Symbol.toStringTag, { value: "Module" })), mt = {
  install(o) {
    Object.entries(Io).forEach(([t, r]) => {
      o.component(r.name || t, r);
    }), Object.entries(ho).forEach(([t, r]) => {
      o.directive(t, r);
    });
  }
};
export {
  Wt as EmojiSkinTone,
  Po as Focus,
  xo as Linkify,
  Mt as MOBILE_BREAKPOINT,
  Ot as MOBILE_SMALL_BREAKPOINT,
  i as NcActionButton,
  e as NcActionButtonGroup,
  m as NcActionCaption,
  a as NcActionCheckbox,
  p as NcActionInput,
  c as NcActionLink,
  s as NcActionRadio,
  N as NcActionRouter,
  f as NcActionSeparator,
  l as NcActionText,
  u as NcActionTextEditable,
  n as NcActions,
  d as NcAppContent,
  g as NcAppContentDetails,
  A as NcAppContentList,
  S as NcAppNavigation,
  b as NcAppNavigationCaption,
  v as NcAppNavigationIconBullet,
  T as NcAppNavigationItem,
  k as NcAppNavigationList,
  P as NcAppNavigationNew,
  x as NcAppNavigationNewItem,
  C as NcAppNavigationSettings,
  I as NcAppNavigationSpacer,
  h as NcAppSettingsDialog,
  E as NcAppSettingsSection,
  B as NcAppSidebar,
  R as NcAppSidebarTab,
  co as NcAutoCompleteResult,
  L as NcAvatar,
  y as NcBreadcrumb,
  M as NcBreadcrumbs,
  O as NcButton,
  D as NcCheckboxRadioSwitch,
  _ as NcColorPicker,
  j as NcContent,
  F as NcCounterBubble,
  ut as NcCustomPickerRenderResult,
  W as NcDashboardWidget,
  w as NcDashboardWidgetItem,
  z as NcDateTime,
  G as NcDateTimePicker,
  V as NcDateTimePickerNative,
  H as NcDialog,
  K as NcDialogButton,
  U as NcEmojiPicker,
  $ as NcEmptyContent,
  q as NcGuestContent,
  J as NcHeaderMenu,
  Q as NcHighlight,
  X as NcIconSvgWrapper,
  Y as NcListItem,
  Z as NcListItemIcon,
  oo as NcLoadingIcon,
  po as NcMentionBubble,
  ro as NcModal,
  to as NcNoteCard,
  io as NcPasswordField,
  eo as NcPopover,
  mo as NcProgressBar,
  ao as NcRelatedResourcesPanel,
  so as NcRichContenteditable,
  No as NcRichText,
  lo as NcSavingIndicatorIcon,
  no as NcSelect,
  uo as NcSelectTags,
  go as NcSettingsInputText,
  Ao as NcSettingsSection,
  So as NcSettingsSelectGroup,
  ko as NcTextArea,
  fo as NcTextField,
  bo as NcTimezonePicker,
  vo as NcUserBubble,
  To as NcUserStatusIcon,
  mt as NextcloudVuePlugin,
  Zt as Tooltip,
  Pt as anyLinkProviderId,
  $t as clickOutsideOptions,
  wt as emojiAddRecent,
  zt as emojiSearch,
  Gt as getCurrentSkinTone,
  xt as getLinkWithPicker,
  Ct as getProvider,
  It as getProviders,
  dt as hasInteractiveView,
  et as isA11yActivation,
  gt as isCustomPickerElementRegistered,
  Jt as isFullscreen,
  Rt as isFullscreenState,
  Xt as isMobile,
  Dt as isMobileState,
  At as isWidgetRegistered,
  St as registerCustomPickerElement,
  bt as registerWidget,
  vt as renderCustomPickerElement,
  Tt as renderWidget,
  ft as richEditor,
  ht as searchProvider,
  Vt as setCurrentSkinTone,
  Et as sortProviders,
  Nt as useFormatDateTime,
  Lt as useIsFullscreen,
  _t as useIsMobile,
  jt as useIsSmallMobile,
  ct as userStatus,
  Kt as usernameToColor
};
